import { assetMimeTypes, AssetMimeTypes, Related, ResourceBase } from '../../resource-types';
import { RawModel } from '../schema';

// TODO: implement this resource so we can paginate
export interface ContentTreeNode extends ResourceBase {
  display_name?: string;
  mime_type?: AssetMimeTypes;
  trashed_at?: string;
  permanently_deleted_at: string;
  relationships: {
    resource: Related<'asset' | 'folder' | 'project'>;
    context: Related<'library' | 'project'>;
    workspace: Related<'workspace'>;
    ancestors: Related<'content-tree-node'>[];
    parent: Related<'content-tree-node'>;
    tags: Related<'tag'>[];
  };
}


export const contentTreeNode: RawModel = {
  type: 'content-tree-node',
  plural: 'content-tree-nodes',
  JSONApi: true,
  useWorker: true,
  canonicalPath: 'nodes',
  serverType: 'node',
  attributes: {
    id: 'UUID',
    display_name: 'string',
    // display_image: 'URL',
    mime_type: Object.values(assetMimeTypes).join(' | ')
  },
  relationships: {
    children: {
      type: 'content-tree-node',
      binding: ['many', 'one'],
      reverse: 'parent_node'
    },
    ancestors: {
      type: 'content-tree-node',
      binding: ['many', 'many']
    },
    resource: {
      type: ['folder', 'asset'],
      binding: ['one', 'one'],
      reverse: 'node',
      required: [true, false]
    }
  }
};
